import React from "react";
import {supabase} from "../services/supabase";
import legalnews from "../assets/legalnewscenter.jpg"

function News(){
    const [news,setNews] = React.useState([]);
    const [loading,setLoading]  = React.useState(true);

    const fetchnews = async () =>{
        setLoading(true);
        const {data,error}= await supabase.from("blogs").select("*").order("created_at",{ascending:false});
        if (error) console.error("Fetch error:", error);
        else {setNews(data);}
        setLoading(false);

    }
    React.useEffect(()=>{
        fetchnews();
    },[]);

    return(
<>
    <div className="bg-gray-50 min-h-screen">
        {/* HEADER */}
        <header className="bg-white border-b">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <div className="flex items-center justify-between py-6">
                    <div className="flex items-center gap-4">
                        <img
                            loading="lazy"
                            src={legalnews}
                            alt="Legal Organization Logo"
                            className="h-12 w-auto"
                        />
                        <div>
                            <h1 className="text-2xl font-extrabold text-gray-900 tracking-tight">
                                Legal News Center
                            </h1>
                            <p className="text-sm text-gray-500">
                                Staying informed on legal developments
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </header>

        {/* CONTENT */}
        <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-10">
            <div className="grid lg:grid-cols-3 gap-10">
                {news.length > 0 && (
                    <>
                        {/* FEATURED ARTICLE */}
                        <article className="lg:col-span-2 bg-white rounded-2xl shadow-sm hover:shadow-md transition overflow-hidden">
                            <img
                                loading="lazy"
                                src={news[0].thumbnail_url || "https://placehold.co/800x400"}
                                alt={news[0].title}
                                className="w-full h-80 object-cover"
                            />
                            <div className="p-8">
                                <div className="flex items-center gap-3 mb-4">
                                    <span className="bg-indigo-100 text-indigo-800 text-xs font-semibold px-3 py-1 rounded-full">
                                        Featured
                                    </span>
                                    <span className="text-sm text-gray-500">
                                        {new Date(news[0].created_at).toLocaleDateString()}
                                    </span>
                                </div>

                                <h2 className="text-2xl font-bold text-gray-900 mb-4 leading-snug">
                                    {news[0].title}
                                </h2>

                                <p className="text-gray-700 leading-relaxed mb-6 line-clamp-3">
                                    {(() => {
                                        try {
                                            const parsed = JSON.parse(news[0].content);
                                            return parsed[0]?.children?.map(c => c.text).join(" ") || "";
                                        } catch {
                                            return news[0].content;
                                        }
                                    })()}
                                </p>

                                <a
                                    href={`/blog/${news[0].slug}`}
                                    className="inline-flex items-center text-indigo-600 font-semibold hover:text-indigo-800"
                                >
                                    Read full article
                                    <span className="ml-2">→</span>
                                </a>
                            </div>
                        </article>

                        {/* SIDEBAR */}
                        <aside className="space-y-6">
                            {news.slice(1, 4).map(item => (
                                <article
                                    key={item.id}
                                    className="bg-white rounded-xl shadow-sm hover:shadow-md transition overflow-hidden"
                                >
                                    <div className="flex gap-4 p-4">
                                        <img
                                            loading="lazy"
                                            src={item.thumbnail_url || "https://placehold.co/150x100"}
                                            alt={item.title}
                                            className="w-28 h-20 object-cover rounded-lg flex-shrink-0"
                                        />
                                        <div className="flex-1">
                                            <div className="flex items-center gap-2 mb-1">
                                                <span className="bg-gray-100 text-gray-700 text-xs font-medium px-2 py-0.5 rounded">
                                                    News
                                                </span>
                                                <span className="text-xs text-gray-400">
                                                    {new Date(item.created_at).toLocaleDateString()}
                                                </span>
                                            </div>

                                            <h4 className="font-semibold text-gray-900 text-sm leading-snug line-clamp-2">
                                                {item.title}
                                            </h4>

                                            <a
                                                href={`/blog/${item.slug}`}
                                                className="text-sm text-indigo-600 hover:text-indigo-800 font-medium inline-block mt-2"
                                            >
                                                Read →
                                            </a>
                                        </div>
                                    </div>
                                </article>
                            ))}
                        </aside>
                    </>
                )}

                {loading && (
                    <p className="text-gray-500 text-center col-span-full">
                        Loading latest news…
                    </p>
                )}
            </div>
        </main>
    </div>
</>

    )
}

export default News;